export enum BillingPaymentType {
    CREDIT_CARD = 'CREDIT_CARD',
    ACH = 'ACH',
}
